import React from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";

import { Button, showNotification } from "fe-shared/src/components";
import { CheckIcon, CloseIcon } from "fe-shared/src/components/Icons";

import {
  resendPickupRequest,
  sendPickupRequest,
} from "../../api/pickupRequests";

interface Props {
  requestNumber: string;
  onSuccess?: () => void;
  isResend?: boolean;
}

const WhiteCheckIcon = (props: React.ComponentProps<typeof CheckIcon>) => (
  <CheckIcon {...props} fillColor="white" />
);

const PickupRequestSendButton = ({
  requestNumber,
  onSuccess,
  isResend = false,
}: Props) => {
  const { t } = useTranslation();

  const [send, sendResult] = useMutation(
    isResend ? resendPickupRequest : sendPickupRequest,
    {
      onSuccess: () => {
        showNotification(
          t(
            isResend
              ? "pickupRequests.details.resendSuccess"
              : "pickupRequests.details.sendSuccess"
          )
        );
        onSuccess?.();
      },
      onError: () => {
        showNotification(
          t("pickupRequests.details.sendError"),
          undefined,
          CloseIcon
        );
      },
    }
  );

  return (
    <Button
      id="request-send-button"
      iconComponent={WhiteCheckIcon}
      iconPosition="left"
      disabled={sendResult.isLoading}
      onClick={() => send(requestNumber)}
    >
      {t("pickupRequests.details.send")}
    </Button>
  );
};

export default PickupRequestSendButton;
